import { UiSource } from '@features/reconciliation/enums'
import type { UiSourceValue } from '@features/reconciliation/enums'

interface BankDisconnectionWidgetContent {
  infoText: string
  title: string
  trackingEvent: string | undefined
  uiSource: UiSourceValue
}

interface GetBankDisconnectionWidgetContentProps {
  isCpa: boolean
  isVariant2: boolean
}

const variant1Content: BankDisconnectionWidgetContent = {
  title: 'dashboard.widget.bank-integration.disconnected.variant1.title',
  infoText: 'dashboard.widget.bank-integration.disconnected.variant1.info_text',
  trackingEvent: 'XXX Reconciliation widget 1 (Client)',
  uiSource: UiSource.WidgetV1,
}

const variant2Content: BankDisconnectionWidgetContent = {
  title: 'dashboard.widget.bank-integration.disconnected.variant2.title',
  infoText: 'dashboard.widget.bank-integration.disconnected.variant2.info_text',
  trackingEvent: 'XXX Reconciliation widget 2 (Client)',
  uiSource: UiSource.WidgetV2,
}

const cpaContent: BankDisconnectionWidgetContent = {
  title: 'dashboard.widget.bank-integration.cpa.empty.title',
  infoText: 'dashboard.widget.bank-integration.cpa.empty.info_text',
  trackingEvent: undefined,
  uiSource: UiSource.CpaWidget,
}

/**
 * Copy, client tracking event and UI source of the disconnected bank widget. CPA clients get their own content;
 * everyone else gets one of the two split test variants.
 */
export const getBankDisconnectionWidgetContent = (
  props: GetBankDisconnectionWidgetContentProps,
): BankDisconnectionWidgetContent => {
  const { isCpa, isVariant2 } = props

  if (isCpa) {
    return cpaContent
  }

  return isVariant2 ? variant2Content : variant1Content
}
